import SectionHeading from "@/components/base/SectionHeading";
import { userVoices } from "@/mocks/categories";

const principles = [
  {
    icon: "ri-shield-check-line",
    title: "多方口径",
    desc: "有争议就并列呈现，不做单方面定论",
  },
  {
    icon: "ri-time-line",
    title: "时间线清晰",
    desc: "按事件顺序梳理，反转也能追得上",
  },
  {
    icon: "ri-user-heart-line",
    title: "尊重当事人",
    desc: "聚焦公开信息，不过度打扰个人生活",
  },
];

export default function VoicesSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-secondary-50 border-y border-secondary-100">
      <SectionHeading
        eyebrow="瓜友怎么说"
        title="一起吃瓜，也一起把瓜吃明白"
        desc="来自常驻瓜友的真实反馈，也是我们持续更新的动力。"
      />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-10 md:mb-12">
        {userVoices.map((voice) => (
          <figure
            key={voice.id}
            className="flex flex-col rounded-lg bg-background-50 border border-secondary-200 p-5 md:p-6"
          >
            <div className="flex gap-2 text-accent-500 mb-3" aria-hidden="true">
              {[0, 1, 2, 3, 4].map((star) => (
                <i key={star} className="ri-star-fill text-sm"></i>
              ))}
            </div>
            <blockquote className="text-sm md:text-base text-foreground-700 leading-relaxed flex-1">
              “{voice.text}”
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3">
              <img
                src={voice.avatar}
                alt={`${voice.name}的头像`}
                title={`${voice.name} - 瓜友会网用户评价`}
                className="w-10 h-10 rounded-full object-cover object-top border border-secondary-200"
              />
              <span className="min-w-0">
                <span className="block text-sm font-medium text-foreground-900 truncate">
                  {voice.name}
                </span>
                <span className="block text-xs text-foreground-400 truncate">
                  {voice.role}
                </span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>

      <div
        id="values"
        className="rounded-lg bg-background-50 border border-secondary-200 p-6 md:p-8"
      >
        <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-5">
          我们坚持的三件事
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {principles.map((item) => (
            <div key={item.title} className="flex items-start gap-3">
              <span className="w-10 h-10 shrink-0 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-900">
                  {item.title}
                </span>
                <span className="block mt-1 text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}